import { useSelector } from 'react-redux';
import UploadingStatusImage from 'assets/icons/UploadStatus/UploadingStatusImage';
import SavedStatusImage from 'assets/icons/UploadStatus/SavedStatusImage';
import FailedStatusImage from 'assets/icons/UploadStatus/FailedStatusImage';
import { CircularProgress, Box } from '@mui/material';
import { selectTransactionStatuses } from 'store/storeTransactionImage/storeTransactionImageSelector';
import styles from './UploadNotification.module.css';

const TransactionItem = ({ transaction, isLast }) => {
    const transactionStatuses = useSelector(selectTransactionStatuses);
    const transactionStatus = transactionStatuses[transaction.transactionId] || 'not_submitted';
    const formatTime = (name) => {
        const timeMatch = name?.match(/(\d{2}:\d{2})/);
        return timeMatch ? timeMatch[1] : '';
    };

    const getTransactionStatus = (images) => {
        const total = images.length;
        const saved = images.filter((img) => img.status === 'saved').length;
        const failed = images.filter((img) => img.status === 'failed').length;
        const uploading = images.filter((img) => img.status === 'uploading' || img.status === 'inFlight').length;
        const hasFinalFailed = images.some((img) => img.isFinalFailed);

        return {
            total,
            saved,
            failed,
            uploading,
            isComplete: saved === total && total > 0,
            hasErrors: failed > 0,
            hasFinalFailed,
            progress: `${saved}/${total}`,
        };
    };

    const status = getTransactionStatus(transaction.images);
    const time = formatTime(transaction.name);

    const getTransactionStatusText = () => {
        if (transactionStatus === 'submitted') {
            return <span className={styles.statusSubmitted}>Submitted</span>;
        }
        if (transactionStatus === 'discarded') {
            return <span className={styles.statusDiscarded}>Discarded</span>;
        }
        return <span>Not Submitted</span>;
    };

    const renderStatusIcon = () => {
        if (status.isComplete) {
            return <SavedStatusImage />;
        }
        if (status.hasErrors) {
            return <FailedStatusImage />;
        }
        return (
            <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
                <UploadingStatusImage />
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        pointerEvents: 'none',
                    }}
                >
                    <CircularProgress size={11} />
                </Box>
            </Box>
        );
    };

    return (
        <div className={`${styles.transactionItem} ${isLast ? '' : styles.withBorder}`}>
            <div className={styles.transactionInfo}>
                <div className={styles.transactionHeader}>
                    <span className={styles.locationName}>{transaction.locationName || 'Unknown Location'}</span>
                    <span className={styles.separator}>|</span>
                    <span className={styles.direction}>{transaction.origin === 'AGENT' ? 'OUT' : 'IN'}</span>
                    <span className={styles.separator}>|</span>
                    <span className={styles.deskName}>Main</span>
                </div>
                <div className={styles.transactionMeta}>
                    {getTransactionStatusText()}
                    <span className={styles.separator}>|</span>
                    <span className={styles.transactionId}>T:{transaction.transactionId}</span>
                    <span className={styles.separator}>|</span>
                    <span className={styles.time}>{time}</span>
                </div>
            </div>
            <div className={styles.progressSection}>
                <span className={styles.progressText}>{status.progress}</span>
                {renderStatusIcon()}
            </div>
        </div>
    );
};

export default TransactionItem;
